import React, { useEffect } from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';

import Header from '../components/special-classes-online/Header';
import Footer from '../components/Footer';

import ContactForm from 'contactfo';

import DiagonalLine from 'aulatime/src/components/DiagonalLine';

import FreshChat from 'aulatime/src/components/FreshChat';

const SpecialClassesOnlinePage = ({ data }) => {
  useEffect(() => {
    const date = new Date(
      new Date().setMinutes(new Date().getMinutes() + 10)
    ).toUTCString();
    document.cookie = `popupRebajas=false; Expires=${date}; Path=/; Secure; SameSite=Lax`;
  }, []);

  const postmanpConfig = {
    ...data.site.siteMetadata.station.metadata,
    ...{ lang: process.env.GATSBY_LOCALE || 'en' },
    ...{ form: 'marketing', plan: '#SpecialClassesOnline' },
  };

  const email = data.site.siteMetadata.station.email;

  return (
    <Layout>
      <SEO title="Special - Classes Online" />
      <main id="special-classes-online" className="marketing">
        <Header />
        <section id="saludar">
          <div className="container">
            <div className="row">
              <div className="col-lg-10 offset-lg-1 col-12 text-center">
                <div className="great-vibes">
                  <h3>Special</h3>
                  <h4>Classes Online</h4>
                </div>

                <h2 className="pt-4">
                  <span className="text-primary">100 hours</span> of private
                  tuition online
                </h2>
                <div className="price-comparison">
                  <p className="pt-4 lead mb-0">Was</p>
                  <div className="row justify-content-center">
                    <div className="col-auto price">
                      <div>
                        <h5>
                          €899,<span>99</span>
                        </h5>
                      </div>
                      <DiagonalLine />
                    </div>
                  </div>

                  <p className="mb-0 pt-3 h3 font-weight-bold">Now</p>
                  <div className="row justify-content-center">
                    <div className="col-auto price">
                      <h5>
                        €799,<span>99</span>
                      </h5>
                      <p className="small">VAT incl.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-10 offset-lg-1 col-12 my-4">
                <div className="col shadow rounded p-4">
                  <div className="row justify-content-center">
                    <div className="col text-center">
                      <h3 className="">Book here</h3>
                      <p className="lead">
                        <a href={`mailto:${email}`}>{email}</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-10 offset-lg-1 col-12 text-center">
                <h3 className="text-primary pt-3">Why Choose Us?</h3>
                <ul className="list-group list-group-flush lead text-center">
                  <li className="list-group-item">
                    <strong>Personalized online tuition</strong> with your own
                    dedicated tutor.
                  </li>
                  <li className="list-group-item">
                    <strong>No recordings, no automations</strong> - just real,
                    live lessons.
                  </li>
                  <li className="list-group-item">
                    <strong>Tailored coaching</strong> to help you speak exactly
                    like the locals.
                  </li>
                  <li className="list-group-item">
                    <strong>Fully flexible hours</strong>, with{' '}
                    <strong>100% recoverable lessons</strong>.
                  </li>
                </ul>

                <p className="h3 pt-4">
                  <span className="text-primary">Book your place now</span> and
                  start learning the right way!
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="contacto">
          <div id="contactoForm">
            <div className="container">
              <div className="rounded col-lg-8 offset-lg-2 col-12 px-0">
                <ContactForm metadata={postmanpConfig} />
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </main>
      <FreshChat config={data.site.siteMetadata.freshchat} />
    </Layout>
  );
};

export default SpecialClassesOnlinePage;

export const query = graphql`
  query {
    site {
      siteMetadata {
        freshchat {
          token
          host
          locale
          siteId
          tags
          config {
            headerProperty {
              appName
              appLogo
              backgroundColor
            }
          }
        }
        station {
          email
          metadata {
            domain
            shortcode
          }
        }
      }
    }
    img: file(
      relativePath: { eq: "special-classes-online/img_valentines.jpg" }
    ) {
      childImageSharp {
        fixed(width: 400) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`;
